import axios, { AxiosResponse } from 'axios'
import {
  FormularioDtoTipoAtendimentoCreate,
  FormularioDtoTipoAtendimentoUnidadeCreate,
  FormularioTipoAtendimentoListQueryResponse,
  FormularioTipoAtendimentoView,
} from './_models'
import { AtendimentoType } from '../../../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL

const FORMULARIOS_URL = `${API_URL}/formularios`
const FORMULARIOS_TIPOS_URL = `${FORMULARIOS_URL}/tipos`

/**
 * Vincula formulário à empresa
 * @param data FormularioDtoTipoAtendimentoCreate
 * @returns FormularioTipoAtendimentoView
 */
export const bindFormularioToEmpresasWithTipos = (
  data: FormularioDtoTipoAtendimentoCreate
): Promise<FormularioTipoAtendimentoView> => {
  return axios
    .post(`${FORMULARIOS_TIPOS_URL}`, data)
    .then((d: AxiosResponse<FormularioTipoAtendimentoView>) => d.data)
}

/**
 * Vincula formulário à unidade
 * @param empresaId Identificador da empresa
 * @param data FormularioDtoTipoAtendimentoUnidadeCreate
 * @returns FormularioTipoAtendimentoView
 */
export const bindFormularioToUnidadesWithTipos = (
  empresaId: number,
  data: FormularioDtoTipoAtendimentoUnidadeCreate
): Promise<FormularioTipoAtendimentoView> => {
  return axios
    .post(`${FORMULARIOS_TIPOS_URL}/${empresaId}`, data)
    .then((d: AxiosResponse<FormularioTipoAtendimentoView>) => d.data)
}

/**
 * Busca todos os vínculos do formulário
 * @param query string
 * @param formularioId Identificador do formulário
 * @returns FormularioTipoAtendimentoListQueryResponse
 */
export const getTiposAtendimentoVinculosByFormularioId = (
  query: string,
  formularioId: number
): Promise<FormularioTipoAtendimentoListQueryResponse> => {
  return axios
    .get(`${FORMULARIOS_TIPOS_URL}/${formularioId}?${query}`)
    .then((resp: AxiosResponse<FormularioTipoAtendimentoListQueryResponse>) => resp.data)
}

/* 
O DELETE recebe parametros id_empresa, id_especialidade e idUnidade. Nesse caso, remove apenas um vínculo.

Passando apenas o parâmetro especialidade, irá remover o vinculo dessa especialidade para todas as empresas.

Passando apenas o parâmetro empresa, irá remover o vínculo para todas as especialidades da empresa.

Se não passar nenhum dos parâmetros, irá remover todos os vínculos do questionário.

*/

/**
 * Desvincula formulário
 * @param formId ID Formulário
 * @param tipoAtendimento AtendimentoType
 * @param empresaId ID Empresa
 * @param unidadeId ID Unidade
 * @returns void
 */
export const deleteTipoAtendimentoVinculo = (
  formId: number,
  tipoAtendimento?: AtendimentoType,
  empresaId?: number,
  unidadeId?: number
): Promise<void> => {
  let query = ''

  if (tipoAtendimento) {
    query += `tipoAtendimento=${tipoAtendimento}`
  }

  if (empresaId) {
    query += (query ? '&' : '') + `idEmpresa=${empresaId}`
  }
  if (unidadeId) {
    query += (query ? '&' : '') + `idUnidade=${unidadeId}`
  }

  return axios.delete(`${FORMULARIOS_URL}/tipo/${formId}?${query}`)
}
